<div class="common-header-font mt-3 ml-2">Change Password</div>
    <div class="ml-5 mt-5">
        <div class="security-label">Current Password</div>
        <div class="flex">
            <input [(ngModel)]="profile.Password" [type]="showPass ? 'text' : 'password'" [disabled]="passDisabled" (focusout)="checkPassword()"
                    pInputText class="mt-2 password-input" [ngClass]="{'input-err-outline': !passCheckSuccess}" placeholder="Enter Current Password" />
            <img *ngIf="profile.Password && !passDisabled" class="pass-visibility-switch-icon" src="../Content/xpress-app/images/operator/eye{{showPass ? '' : '-slash'}}.svg" (click)="changePasswordVisibility()" />
            <img *ngIf="passDisabled" class="pass-visibility-switch-icon" src="../Content/xpress-app/images/operator/signup/signup-step-check.svg" width="19px" />
        </div>
        <div class="hidden mt-1" [ngClass]="{'passErr': !passCheckSuccess}">Incorrect Password</div>

        <div class="security-label mt-3">New Password</div>
        <div class="flex">
            <input [(ngModel)]="profile.NewPassword" [type]="showNewPass ? 'text' : 'password'"  (keyup)="scorePassword()" (focusin)="openPasswordTips()" (focusout)="closePasswordTips()"
                    pInputText class="mt-2 password-input" placeholder="Enter New Password" />
            <img *ngIf="profile.NewPassword" class="pass-visibility-switch-icon" src="../Content/xpress-app/images/operator/eye{{showNewPass ? '' : '-slash'}}.svg" (click)="changeNewPasswordVisibility()" />
        </div>

        <div *ngIf="showPasswordTips" class="password-tips">
            <div class="header">Password Strength:</div>
            <div class="password-progress">
                <div class="progress" [ngStyle]="{ width: passProgressBar + '%', backgroundColor: passPBColor }"></div>
            </div>
            <div class="common-font enter-pass" style="margin-top: 17px;">{{passScoreStr}}</div>
            <span class="gray-line-pass"></span>
            <div class="common-font enter-pass">Suggestions</div>

            <ul class="mt-0 common-font enter-pass" style="margin-left: -15px">
                <li class="mb-1" [ngClass]="{'pass-req-met': isPassLowercase}">At least one lowercase</li>
                <li class="mb-1" [ngClass]="{'pass-req-met': isPassUppercase}">At least one uppercase</li>
                <li class="mb-1" [ngClass]="{'pass-req-met': isPassNumeric}">At least one numeric</li>
                <li class="mb-1" [ngClass]="{'pass-req-met': isPassMinLength}">Minimum 8 characters</li>
            </ul>
        </div>

        <div class="security-label mt-3">Re-enter Password</div>
        <div class="flex">
            <input [(ngModel)]="profile.ConfirmPassword" [type]="showConfirmPass ? 'text' : 'password'" (focusout)="confirmPassword()"
                    pInputText class="mt-2 password-input" [ngClass]="{'input-err-outline': !passConfirmSuccess}" placeholder="Confirm New Password" />
            <img *ngIf="profile.ConfirmPassword && !passConfirmSuccess" class="pass-visibility-switch-icon" src="../Content/xpress-app/images/operator/eye{{showConfirmPass ? '' : '-slash'}}.svg" (click)="changeConfirmPasswordVisibility()" />
            <img *ngIf="profile.ConfirmPassword && passConfirmSuccess" class="pass-visibility-switch-icon" src="../Content/xpress-app/images/operator/signup/signup-step-check.svg" width="19px" />
        </div>
        <div class="hidden mt-1" [ngClass]="{'passErr': !passConfirmSuccess}">Password not match</div>

        <div class="flex title-float-right left-block-bottom-btns mt-3">
            <div [ngClass]="{'btn-disabled': (passScoreStr !== PassScoreEnum[PassScoreEnum.Strong]) || !passCheckSuccess 
            || Utils.isNullOrEmpty(this.profile.NewPassword) || Utils.isNullOrEmpty(this.profile.ConfirmPassword) 
            || Utils.isNullOrEmpty(this.profile.Password) || !passConfirmSuccess}" 
         class="btn-profile btn-default btn-update-pass" (click)="changePassword()">Update Password</div>
        </div>
    </div>